<template>
  <div>
    <eAnonymComplModal v-bind="cProp" @snackbar-msg="mxfSendParent('snackbar-msg', $event)" @close="fGoToDetail" /> 
  </div>
</template>

<script>
import eAnonymComplModal from '@/components/EComplaints/complaintDetail/modals/eAnonymComplModal'
export default {
  components: { 
    eAnonymComplModal 
    },
  methods:{
    // Accede al detalle de un sobre 
    fGoToDetail(complaintInfo){
      this.$emit('go-to-detail-view', complaintInfo)
    }
  },
  computed: {
    cProp(){
      return this.$route.query
    }
  }
}
</script>